import React from 'react';
import withRouter from "../../custom/withRouter";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import $ from "jquery"
import toggleMenu from '../../../redux/SideBar/sideBarActions';
import { connect } from 'react-redux';
import CommonIcon from '../../helpers/icons';
import { ToastContainer } from 'react-toastify';
import SubscriptionListViewTable from '../../custom/SubscriptionListView';
import { FormLabel } from 'react-bootstrap';
import { DownloadPdf, GetInvoiceData, GetInvoiceSummary, GetParticularInvoice, GetParticularInvoiceLineItems } from '../../../action/InvoiceApi';
import { TextField, Button } from '@material-ui/core';
// import { Autocomplete } from '@mui/lab';
import { Autocomplete } from '@mui/material';
import CustomListView from '../MUIDataTable/CustomListView';


class Billpayments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isWebMobile: false, // Or get it from props if necessary: this.props.isWebMobile
            columnHeadersRoles: [
                { key: "InvoiceNo", label: "Invoice Number", width: "20%" },
                { key: "InvoiceDate", label: "Invoice Date", width: "20%" },
                { key: "totalAmount", label: "Total Amount", width: "20%" },
                { key: "status", label: "Status", width: "20%" },
                { key: "actiondownload", label: "Action", width: "20%" },
            ],
            columnHeaderInvoiceItems: [
                { key: "applicationName", label: "Subscription", width: "30%" },
                { key: "type", label: "Type", width: "20%" },
                { key: "interval", label: "Interval", width: "20%" },
                { key: "licenseAssigned", label: "License Assigned", width: "20%" },
                { key: "cost", label: "Cost (₹)", width: "15%" },
                { key: "amount", label: "Amount (₹)", width: "15%" },
            ],
            invoicedata: [],
            invoiceitemsdata: [],

            invoiceNumber: '',
            invoiceDate: '',
            billingCycle: '',
            dueDate: '',
            currencySymbol: '',
            tableLoader: false,
            invoicePDF: '',
            status: '',
            invoiceSummary: [],
            filters: {
                limit: 15,
                offset: 0,
                sortBy: 'InvoiceNo',
                pageNumber: 1,
                PageSize: 10,
                sortOrder: 'asc',
            },
            filters1: {
                limit: 15,
                offset: 0,
                sortBy: 'applicationName',
                pageNumber: 1,
                PageSize: 10,
                sortOrder: 'asc',
            },
            choice: {

                invoice_number: '',
                status: '',
                invoice_date: '',
                invoice_todate: '',
                invoice_fromdate: ''
            },
            currentPage: 0,
            totalPages: 0,
            totalCount: 0,
            languages: [],
            columns: [
                {
                    accessorKey: 'invoiceNumber',
                    header: 'Invoice Number',
                },
                {
                    accessorKey: 'invoiceDate',
                    header: 'Invoice Date',
                },
                {
                    accessorKey: 'totalAmount',
                    header: 'Total Amount',
                },
                {
                    accessorKey: 'status',
                    header: 'Status',
                },
                {
                    accessorKey: 'action',
                    header: 'Action',
                    minSize: 90,
                    maxSize: 90,
                    enableColumnActions: false,
                    enableSorting: false,
                    enableColumnFilter: false
                }
            ]
        };

    }
    handleDataFetch = (pageSize, pageIndex, columnsFilters, sorting) => {
        this.setState({ pageSize: pageSize, pageIndex: pageIndex, columnFilter: columnsFilters, sortingFilters: sorting });

        const filterObject = columnsFilters.reduce((acc, curr) => {
            acc[curr.id] = curr.value;
            return acc;
        }, {});
        let sortorder = !sorting[0]?.desc;
        let data = {
            Name: filterObject.name ?? "",
            Email: filterObject.email ?? "",
            SortBy: sorting[0]?.id ?? "name",
            SortOrder: sortorder ? "asc" : 'desc',
            PageNumber: pageSize + 1,
            PageSize: pageIndex,

        };

        console.log(data);
        this.setState({ tableLoader: true });
        this.props.dispatch(GetInvoiceData()).then((res) => {
            console.log(res);
            this.setState((prev) => ({
                invoicedata: res.data,
                invoiceNumber: res.data.invoiceNumber,
                currencySymbol: res.data[0]?.currencySymbol,
                totalCount: res.pagination.totalCount, totalPages: res.pagination.totalPages, currentPage: res.pagination.currentPage, filters: {
                    ...prev.filters,
                    PageSize: res.pagination.pageSize,
                }

            }))
            this.setState({ tableLoader: false });
        })
            .catch((error) => {
                console.log(error);
                this.setState({ tableLoader: false });
            })
    }
    componentDidMount() {
        // FISRT API

        // this.props.dispatch(GetInvoiceData()).then((res) => {
        //     console.log(res);
        //     this.setState((prev) => ({
        //         invoicedata: res.data,
        //         invoiceNumber: res.data.invoiceNumber,
        //         currencySymbol: res.data[0]?.currencySymbol,
        //         totalCount: res.pagination.totalCount, totalPages: res.pagination.totalPages, currentPage: res.pagination.currentPage, filters: {
        //             ...prev.filters,
        //             PageSize: res.pagination.pageSize,
        //         }

        //     }))
        // })

        const intervals = setInterval(() => {
            this.resize();
        }, 10)
    }

    handleChange = (event, newValue) => {
        this.setState({ value: newValue });
    };
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true,
            })
        } else {
            this.setState({
                isMobile: false,
                isWebMobile: false
            })
        }

        if (window.innerWidth < 468) {
            this.setState({
                isMobile600: true,
                isWebMobile: true
            })
        } else {
            this.setState({
                isMobile600: false,
                isWebMobile: false
            })
        }

        if (window.innerWidth < 380) {
            this.setState({
                isMobile380: true
            })
            this.setState({
                isMobile380: true
            })
        } else {
            this.setState({
                isMobile380: false
            })
        }
        this.setState({
            height: window.innerHeight
        })
    };

    handleScroll = () => {
        // if (!this.state.isScroll) {
        //     this.setState(
        //         (prevState) => ({
        //             ...prevState, isLoader: true,
        //             filtered: {
        //                 ...prevState.filtered,
        //                 offset: prevState.filtered.offset + 10,
        //             },
        //         }),
        //         () => {
        //             let tableLoader = true;
        //             this.getAllApplicationData(this.state.filtered, tableLoader);
        //         }
        //     );
        // }
    };



    closeForm = () => {
        $("#AddForm2").removeClass("show");
        $(".offcanvas-backdrop").removeClass("show");
        $("body").removeClass("scrollhide");
        $(".main-content").removeClass("scrollhide");

    };

    handleInvoiceEdit = (invoiceId) => {
        console.log(invoiceId);
        let data = {
            applicationname: '',
            type: '',
            billingfromdate: '',
            billingtodate: '',
            sortby: this.state.filters1.sortBy,
            sortorder: this.state.filters1.sortOrder,
            pagenumber: 1,
            pagesize: 10,
        }
        this.props.dispatch(GetParticularInvoice(invoiceId)).then((res) => {
            this.setState({
                invoiceNumber: res.data.invoiceNumber,
                invoiceDate: res.data.invoiceDate,
                billingCycle: res.data.billingCycle,
                dueDate: res.data.due_date,
                currencySymbol: res.data.currencySymbol,
                invoicePDF: res.data.invoicePdfUrl,
                status: res.data.status

            })
        })
        this.props.dispatch(GetParticularInvoiceLineItems(invoiceId, data)).then((res) => {
            this.setState({ invoiceitemsdata: res.data })
        })

        this.props.dispatch(GetInvoiceSummary(invoiceId)).then((res) => {
            this.setState({ invoiceSummary: res.data })
        })

        let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("AddForm2")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        $(".main-content").addClass("scrollhide");
        this.setState({
            backdrop: true,
        });
    }

    toggleWebFilter = () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("FilterScreen1")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        $(".main-content").addClass("scrollhide");
        this.setState({});
    };

    closeWebFilter = () => {
        $("#FilterScreen1").removeClass("show");
        $("body").removeClass("scrollhide");
        $(".main-content").removeClass("scrollhide");
        this.setState({ rows: [] });
        this.setState({
            choice: {
                application: "",
                subscriptionStatus: null,
                purchasedDate: null,
            },
        });
    };

    lookupChange = (e, selectedValue, title) => {
        if (title === "invoice_number") {
            this.setState({
                choice: { ...this.state.choice, invoice_number: e.target.value },
            });
        }
        if (title === "status") {
            if (selectedValue !== null) {
                this.setState({
                    choice: {
                        ...this.state.choice,
                        status: selectedValue.status,
                    },
                });
            } else {
                this.setState({
                    choice: { ...this.state.choice, status: null },
                });
            }
        }
        if (title === "invoice_fromdate") {
            const formattedDate = new Date(e.target.value).toISOString();
            console.log(formattedDate);
            this.setState({
                choice: { ...this.state.choice, invoice_fromdate: e.target.value },
            });
        }
        if (title === "invoice_todate") {
            const formattedDate = new Date(e.target.value).toISOString();
            console.log(formattedDate);
            this.setState({
                choice: { ...this.state.choice, invoice_todate: e.target.value },
            });
        }
    };

    applyFilter = () => {
        const { choice, filters } = this.state;
        const data = {

            limit: 15,
            offset: 0,
            invoice_number: choice.invoice_number,
            invoice_from_date: choice.invoice_fromdate,
            invoice_to_date: choice.invoice_todate,
            status: choice.status,
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder
        };
        console.log(data);


        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                // application: choice.application,
                // subscriptionStatus: choice.subscriptionStatus,
                // purchasedDate: choice.purchasedDate,
            },
            invoicedata: [],
            groupedData: {},
            groupedColumn: null,
            filtered: data,
            isGroupBy: true,
            tableLoader: true
        }), () => {
            this.props.dispatch(GetInvoiceData(data)).then((res) => {
                this.setState({ invoicedata: res.data })
                this.setState((prev) => ({
                    totalCount: res.pagination.totalCount, totalPages: res.pagination.totalPages, currentPage: res.pagination.currentPage, filters: {
                        ...prev.filters,
                        PageSize: res.pagination.pageSize,

                    }
                }), () => {
                    console.log(this.state.filters.pageNumber, this.state.filters.PageSize, this.state.currentPage);

                })

            })
            this.closeWebFilter();
        });
    };


    clearFilter = () => {
        this.setState((prevState) => ({
            filters: {
                ...prevState.filters,
            },
            choice: {
                ...prevState.choice,
            },
            normalData: [],
            groupedData: {},
            groupedColumn: null,
            isGroupBy: true,
        }), () => {
            const data = {
                sortBy: this.state.filters.sortBy,
                sortOrder: this.state.filters.sortOrder,

            };

            this.props.dispatch(GetInvoiceData(data)).then((res) => {
                this.setState({ invoicedata: res.data })
                this.setState((prev) => ({
                    totalCount: res.pagination.totalCount, totalPages: res.pagination.totalPages, currentPage: res.pagination.currentPage, filters: {
                        ...prev.filters,
                        PageSize: res.pagination.pageSize,

                    }
                }), () => {
                    console.log(this.state.filters.pageNumber, this.state.filters.PageSize, this.state.currentPage);

                })

            })
            this.closeWebFilter();
        });
    }

    handleSortRole = (column) => {
        let { filters } = this.state;
        let sortOrder = 'asc';

        if (filters.sortBy === column && filters.sortOrder === 'asc') {
            sortOrder = 'desc';
        }
        const data = {
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder,
            PageNumber: 1,
            PageSize: 10
        };
        this.state.groupedColumn = null;
        this.state.invoicedata = []
        this.state.groupedData = {};
        this.state.filters.sortBy = column;
        this.state.filters.sortOrder = sortOrder;
        this.props.dispatch(GetInvoiceData(data)).then((res) => {
            this.setState({ invoicedata: res.data })
            this.setState((prev) => ({
                totalCount: res.pagination.totalCount, totalPages: res.pagination.totalPages, currentPage: res.pagination.currentPage, filters: {
                    ...prev.filters,
                    PageSize: res.pagination.pageSize,

                }
            }), () => {
                console.log(this.state.filters.pageNumber, this.state.filters.PageSize, this.state.currentPage);

            })
        })
    };

    handlePagePerPage = (value) => {

        console.log(value);

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                PageSize: value
            },

            groupedData: {},
            groupedColumn: null,
            tableLoader: true
        }), () => {
            let data = {
                PageSize: value,
                PageNumber: this.state.filters.pageNumber,

            }
            this.props.dispatch(GetInvoiceData(data)).then((res) => {
                this.setState({ invoicedata: res.data })
                this.setState((prev) => ({
                    totalCount: res.pagination.totalCount, totalPages: res.pagination.totalPages, currentPage: res.pagination.currentPage, filters: {
                        ...prev.filters,
                        PageSize: res.pagination.pageSize,

                    }
                }), () => {
                    console.log(this.state.filters.pageNumber, this.state.filters.PageSize, this.state.currentPage);

                })

            })
        })
    }

    handlePagination = (newPage) => {


        console.log('New Page:', newPage);
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                // pageNumber: newPage
            },

            groupedData: {},
            groupedColumn: null,

            tableLoader: true
        }), () => {
            let data = {
                PageSize: this.state.filters.PageSize,
                PageNumber: newPage,
            }
            this.props.dispatch(GetInvoiceData(data)).then((res) => {
                this.setState({ invoicedata: res.data })
                this.setState((prev) => ({
                    totalCount: res.pagination.totalCount, totalPages: res.pagination.totalPages, currentPage: res.pagination.currentPage, filters: {
                        ...prev.filters,
                        PageSize: res.pagination.pageSize,

                    }
                }), () => {
                    console.log(this.state.filters.pageNumber, this.state.filters.PageSize, this.state.currentPage);

                })

            })
        })


    };

    formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' }); // e.g., 'Jul'
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        const formattedHours = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        return `${day} ${month} ${year}`;
    };

    formatDateOnly = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' }); // e.g., 'Jul'
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        const formattedHours = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        return `${day} ${month}`;
    };

    downloadFile = (fileBytes, fileName) => {

        const byteCharacters = atob(fileBytes);

        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {

            byteNumbers[i] = byteCharacters.charCodeAt(i);

        }

        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: 'application/octet-stream' });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');

        a.href = url;

        a.download = fileName;

        document.body.appendChild(a);

        a.click();

        window.URL.revokeObjectURL(url);

        document.body.removeChild(a);

    };


    downloadPdf = (url) => {
        console.log(url);

        if (url) {
            this.props.dispatch(DownloadPdf(url)).then((res => {
                this.downloadFile(res.data.fileBytes, res.data.fileName)
            }))
        }

    }


    render() {
        const { isWebMobile } = this.state;


        return (
            <>
                {!isWebMobile ?
                    <div className='mainSetting h-100'>
                        <div className='row'>
                            <div className="row w-100">
                                <div className="col-8">
                                    <span className="headerformpayments">Bills and Payments</span>
                                </div>
                                <div className='col-4'>
                                    {/* <button className=' btn-fun ps-2 pe-2 float-end me-4' type="button" onClick={this.toggleWebFilter}><CommonIcon fileName={'Filter'} /> </button>{' '} */}
                                </div>
                            </div>
                        </div>
                        <div className="row w-100 h-100" style={{paddingRight:'1rem'}}>
                            <div className='h-100  mt-1'>
                                {/* <SubscriptionListViewTable
                                    scrollRef={this.tableRef}
                                    handleScroll={this.handleScroll}
                                    columns={this.state.columnHeadersRoles}
                                    data={this.state.groupedData}
                                    value={this.state.invoicedata}
                                    handleSort={this.handleSortRole}
                                    downloadPdf={this.downloadPdf}
                                    toggleGroup={this.toggleGroup}
                                    groupedName={this.state.groupedColumn}
                                    collapsedGroups={this.state.collapsedGroups}
                                    sortConfig={this.state.filters}
                                    handleDelete={this.handleDelete}
                                    handleDeleteChangeId={this.handleDeleteId}
                                    isLoader={this.props.userRoleAssign}
                                    handleInvoiceEdit={this.handleInvoiceEdit}
                                    paginatedData={this.handlePagination}
                                    rowPerPage={this.handlePagePerPage}
                                    pagesize={this.state.filters.PageSize}
                                    pagenumber={this.state.filters.pageNumber}
                                    totalcount={this.state.totalCount}
                                    totalpages={this.state.totalPages}
                                    currentPage={this.state.currentPage}
                                /> */}
                                <CustomListView
                                    listData={this.state.invoicedata}
                                    columns={this.state.columns}
                                    handleDataFetch={this.handleDataFetch}
                                    totalCount={this.state.totalCount}
                                    isLoading={this.state.tableLoader}
                                />
                            </div>
                        </div>
                        {/* <div
                            className="offcanvas offcanvas-end p-3 ps-4 pb-0 pt-0"
                            data-bs-scroll="false"
                            data-bs-backdrop
                            id="AddForm2"
                            aria-labelledby="offcanvasScrollingLabel"
                            style={{
                                width: "calc(100% - 241px)",

                                height: '100vh',
                                overflowX: 'scroll'

                            }}
                        >
                            <div className='d-flex justify-content-between ps-1 pt-0'>
                                <h3 className='headername3 pt-3'>Invoice summary</h3>
                                <div>
                                    <button className='statusinvoice me-1'>
                                        Paid
                                    </button>
                                    <button
                                        data-bs-dismiss="offcanvas"
                                        className="offcavasclose float-end "
                                        onClick={() => this.closeForm()}
                                    >
                                        <CommonIcon fileName={"Close"} />
                                    </button>
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-start ps-1 me-2' >
                                <div>
                                    <div className='d-flex align-items-start mt-1'><FormLabel className="formlabel-style1">Invoice number</FormLabel><span className={`formlabel-input `}>&nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;{this.state.invoiceNumber}</span></div>
                                    <div className='d-flex align-items-start mt-1'><FormLabel className="formlabel-style1">Invoice date</FormLabel><span className={`formlabel-input `}>&nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;{this.formatDate(this.state.invoiceDate)}</span></div>
                                    <div className='d-flex align-items-start mt-1'><FormLabel className="formlabel-style1">Billing cycle</FormLabel><span className={`formlabel-input `}>&nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;{this.state.billingCycle}</span></div>
                                    <div className='d-flex align-items-start mt-1'><FormLabel className="formlabel-style1">Due on</FormLabel><span className={`formlabel-input `}>&nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;{this.state.dueDate}</span></div>
                                </div>
                                <button className='btn-fun ps-3 pe-3 fs-7' onClick={() => this.downloadPdf(this.state.invoicePDF)}> Download PDF</button>
                            </div>
                            <div >
                                <label className='ps-1 invoiceitemslabel mt-2'>Invoice items</label>
                                <div className='mt-2'>
                                    <SubscriptionListViewTable
                                        scrollRef={this.tableRef}
                                        handleScroll={this.handleScroll}
                                        columns={this.state.columnHeaderInvoiceItems}
                                        data={this.state.groupedData}
                                        value={this.state.invoiceitemsdata}
                                        handleSort={this.handleSortRole}
                                        toggleGroup={this.toggleGroup}
                                        groupedName={this.state.groupedColumn}
                                        collapsedGroups={this.state.collapsedGroups}
                                        sortConfig={this.state.filters1}
                                        handleDelete={this.handleDelete}
                                        handleDeleteChangeId={this.handleDeleteId}
                                        isLoader={this.props.userRoleAssign}
                                        invoice={true}
                                        currencySymbol={this.state.currencySymbol}
                                    />
                                </div>
                            </div>
                            <div className=''>
                                <div className='float-end me-5'>
                                    {this.state.invoiceSummary.map((e) => {
                                        return (
                                            <div className='d-flex col-12'>
                                                <label className='col-8 me-2 invoiceitemlabel'>{e.type}</label>
                                                <span className='col-4 invoicerupees'>{this.state.currencySymbol + e.value}</span>
                                            </div>
                                        )
                                    })}
                                </div>

                            </div>


                        </div> */}

                        {/* FILTER SCREEN */}
                        {/* <div
                            className="offcanvas offcanvas-end"


                            data-bs-scroll="false"
                            data-bs-backdrop="false"
                            id="FilterScreen1"
                            aria-labelledby="offcanvasScrollingLabel"
                        >
                            <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                                <h6
                                    id="offcanvasRightLabel"
                                    className="modal-title head-span"
                                    style={{ fontWeight: "600" }}
                                >
                                    Filter
                                </h6>
                                <button
                                    className="offcavasclose"
                                    onClick={() => this.closeWebFilter()}
                                >
                                    <CommonIcon fileName={"Close"} />
                                </button>
                            </div>

                            <div className="offcanvas-body px-4 pt-0">
                                <div className="row">
                                    <div
                                        className="row"
                                        style={{ padding: "1rem", paddingTop: "0" }}
                                    >
                                        <div className={`col-12 mt-2`}>
                                            <TextField
                                                id="jobOpTitle"
                                                className="filter_input"
                                                fullWidth
                                                label="Invoice Number"
                                                variant="filled"
                                                value={this.state.choice.invoice_number}
                                                onChange={(e) =>
                                                    this.lookupChange(e, "", "invoice_number")
                                                }
                                                focused
                                            />
                                        </div>
                                        <div className={`col-12 mt-2`}>

                                            <TextField
                                                type='date'
                                                id='jobOpOpenPositions'
                                                fullWidth
                                                label="Invoice from date"
                                                className='filter_input'
                                                variant="filled"
                                                value={this.state.choice.invoice_date}
                                                onChange={(e) => this.lookupChange(e, "", "invoice_fromdate")}
                                                focused
                                                disablePortal
                                            />
                                        </div>
                                        <div className={`col-12 mt-2`}>

                                            <TextField
                                                type='date'
                                                id='jobOpOpenPositions'
                                                fullWidth
                                                label="Invoice to date"
                                                className='filter_input'
                                                variant="filled"
                                                value={this.state.choice.invoice_date}
                                                onChange={(e) => this.lookupChange(e, "", "invoice_todate")}
                                                focused
                                                disablePortal
                                            />
                                        </div>
                                        <div className={`col-12 mt-2`}>
                                            <Autocomplete
                                                focused
                                                id="roleId"
                                                variant="filled"
                                                disablePortal
                                                value={this.state.choice.status ? { status: this.state.choice.status } : null}
                                                options={[
                                                    { id: "1", status: "Paid" },
                                                    { id: "2", status: "Pending" },
                                                    { id: "3", status: "Due" },

                                                ]}
                                                getOptionLabel={(option) => option.status || ""}
                                                onChange={(e, selectedValue) =>
                                                    this.lookupChange(
                                                        e,
                                                        selectedValue,
                                                        "type"
                                                    )
                                                }
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props} key={option.id}>
                                                        {option.status}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="filled"
                                                        className="filter_input"
                                                        focused
                                                        label="Status"
                                                    />
                                                )}
                                            />
                                        </div>


                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 align_justify_end pb-20 pr-54">
                                    <Button
                                        className="btn-clear mr-10 border-none"
                                        variant="outlined"
                                        onClick={() => this.clearFilter()}
                                    >
                                        Reset
                                    </Button>
                                    <button
                                        className="btn-apply"
                                        variant="primary"
                                        onClick={() => this.applyFilter()}
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    :
                    <div className='mobilemain'> {/* This should handle the mobile version if needed */}
                        {/* Mobile version content */}
                        <div className="row">
                            <ToastContainer />
                            {/* <div className="col-12 titlebar-mob"> */}
                            <div className='row'>
                                <div className='col-2  pt-1'>
                                    <span className='mobile-bill' onClick={() => this.props.toggleMenu()}><CommonIcon fileName={'Menu'} /></span>
                                </div>
                                <div className='col-8 ps-2 pt-2'>
                                    <span className="headerform-mobilebills">Bills and Payments</span>
                                </div>
                                <div className='col-2 pt-1 ps-0 '>
                                    <button className='btn-fun ps-3 pe-3' type="button" onClick={this.toggleWebFilter}><CommonIcon fileName={'Filter'} /> </button>{' '}
                                </div>

                            </div>
                            <div className="row w-100 ms-1">
                                <div className="row w-100 h-100">


                                    <div className='groupcardmobile ps-1'>

                                        {!this.props.isLoading && this.state.invoicedata.length < 1 ?

                                            <div className="card sharpcorner  cursor-pointer px-2 my-2 mt-2 p-2" style={{ width: "94%" }} >
                                                <div className="card-body">
                                                    <div style={{ position: 'absolute', left: '0', top: '-0.1px', bottom: '-0.2px', width: '4px', backgroundColor: " rgb(33, 150, 243)" }}>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12  d-flex align-items-center">
                                                            <div className="row text-center w-100">
                                                                <div className="col-12"><span className="nofound " style={{ fontWeight: "bold" }}>No records found</span></div>
                                                                {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :


                                            this.state.invoicedata.map((element, inde) => {
                                                return (
                                                    <div className="card sharpcorner  cursor-pointer px-2 my-2 mt-4 pt-1 pb-2" style={{ width: "94%", minHeight: '162px' }} >
                                                        <div className="card-body pt-0 pb-0">
                                                            <div style={{ position: 'absolute', left: '0', top: '-0.1px', bottom: '-0.2px', width: '4px', backgroundColor: " rgb(33, 150, 243)" }}>
                                                            </div>
                                                            <div className="row">
                                                                <div className={`col-12 d-flex align-items-center mb-1 ${this.state.isMobile ? "pt-2" : ""}`} onClick={() => this.handleInvoiceEdit(element.invoiceId)}>
                                                                    <div className="row">
                                                                        <div className="col-12"><span className="reporttext14mobile" style={{ fontWeight: "bold" }}>{element.invoiceNumber}</span></div>
                                                                        {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                                                                    </div>
                                                                </div>
                                                                {/* <div className="col-6 d-flex align-items-start">
                                                                    <div className="row ">
                                                                        <div className="col-12"><span className="reporttext14mobile" >Invoice Number</span></div>
                                                                        <div className="col-12"><span className="reporttext12" >{element.invoiceNumber}</span></div>
                                                                    </div>
                                                                </div> */}
                                                                <div className="col-6 d-flex align-items-start" onClick={() => this.handleInvoiceEdit(element.invoiceId)}>
                                                                    <div className="row desc">
                                                                        <div className="col-12"><span className="reporttext14mobile" >Invoice Date</span></div>
                                                                        <div className="col-12"><span className="reporttext12desc" > {this.formatDate(element.invoiceDate)}</span></div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-6 d-flex align-items-start" onClick={() => this.handleInvoiceEdit(element.invoiceId)}>
                                                                    <div className="row desc">
                                                                        <div className="col-12"><span className="reporttext14mobile" >Total Amount</span></div>
                                                                        <div className="col-12"><span className="reporttext12desc" > {element.totalAmount}</span></div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-6 d-flex align-items-start" onClick={() => this.handleInvoiceEdit(element.invoiceId)}>
                                                                    <div className="row desc">
                                                                        <div className="col-12"><span className="reporttext14mobile" >Status</span></div>
                                                                        <div className="col-12"><span className="reporttext12desc" > {element.status}</span></div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-6 d-flex align-items-start">
                                                                    <div className="row desc">
                                                                        <div className="col-12"><span className="reporttext14mobile" >Action</span></div>
                                                                        <div className="col-12"><span className="reporttext12desc" onClick={() => this.downloadPdf(element.invoiceUrl)}><CommonIcon fileName={'downloadbill'} /></span></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>)
                                            })
                                        }
                                    </div>
                                </div>
                                <div
                                    className="offcanvas offcanvas-end p-3 ps-4 pb-0 pt-0"
                                    data-bs-scroll="false"
                                    data-bs-backdrop
                                    id="AddForm2"
                                    aria-labelledby="offcanvasScrollingLabel"
                                    style={{
                                        width: "calc(100% - 241px)",

                                        height: '100vh',
                                        overflowX: 'scroll'

                                    }}
                                >
                                    <div className='d-flex justify-content-between ps-1 pt-0'>
                                        <h3 className='headername3 pt-3'>Invoice summary</h3>
                                        <div>

                                            <button
                                                data-bs-dismiss="offcanvas"
                                                className="offcavasclose float-end "
                                                onClick={() => this.closeForm()}
                                            >
                                                <CommonIcon fileName={"Close"} />
                                            </button>
                                            <button className='statusinvoice me-1'>
                                                Paid
                                            </button>
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-between align-items-start ps-1 me-2' >
                                        <div>
                                            <div className=' mt-1 '><FormLabel className="formlabel-style1 d-block">Invoice number</FormLabel><span className={`formlabel-input `}>{this.state.invoiceNumber}</span></div>
                                            <div className=' mt-1'><FormLabel className="formlabel-style1 d-block">Invoice date</FormLabel><span className={`formlabel-input `}>{this.formatDate(this.state.invoiceDate)}</span></div>
                                            <div className=' mt-1'><FormLabel className="formlabel-style1 d-block">Billing cycle</FormLabel><span className={`formlabel-input `}>{this.state.billingCycle}</span></div>
                                            <div className=' mt-1'><FormLabel className="formlabel-style1 d-block">Due on</FormLabel><span className={`formlabel-input `}>{this.state.dueDate}</span></div>
                                        </div>
                                        <button className='btn-fun ps-3 pe-3 fs-7'><a href={this.state.invoicePDF} className='downloadtag' download><CommonIcon fileName={'downloadicon'} /> Download PDF</a></button>
                                    </div>

                                    <div >
                                        <label className='ps-1 invoiceitemslabel mt-2'>Invoice items</label>
                                        <div className='mt-2'>
                                            <div className='groupcardmobileinvoice ms-0'>

                                                {!this.props.isLoading && this.state.invoicedata.length < 1 ?

                                                    <div className="card sharpcorner  cursor-pointer px-2 my-2 mt-2 p-2" style={{ width: "94%" }} >
                                                        <div className="card-body">
                                                            <div style={{ position: 'absolute', left: '0', top: '-0.1px', bottom: '-0.2px', width: '4px', backgroundColor: " rgb(33, 150, 243)" }}>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12  d-flex align-items-center">
                                                                    <div className="row text-center w-100">
                                                                        <div className="col-12"><span className="nofound " style={{ fontWeight: "bold" }}>No records found</span></div>
                                                                        {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :


                                                    this.state.invoiceitemsdata.map((element, inde) => {
                                                        return (
                                                            <div className="card sharpcorner  cursor-pointer px-2 my-2 mt-4 pt-1 pb-1" style={{ width: "94%", minHeight: '162px' }}>
                                                                <div className="card-body pt-0 pb-0">
                                                                    <div style={{ position: 'absolute', left: '0', top: '-0.1px', bottom: '-0.2px', width: '4px', backgroundColor: " rgb(33, 150, 243)" }}>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className={`col-12 d-flex align-items-center mb-1 ${this.state.isMobile ? "pt-2" : ""}`}>
                                                                            <div className="row">
                                                                                <div className="col-12"><span className="reporttext14mobile" style={{ fontWeight: "bold" }}>{element.applicationName}</span></div>
                                                                                {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                                                                            </div>
                                                                        </div>
                                                                        {/* <div className="col-6 d-flex align-items-start">
                            <div className="row ">
                                <div className="col-12"><span className="reporttext14mobile" >Invoice Number</span></div>
                                <div className="col-12"><span className="reporttext12" >{element.invoiceNumber}</span></div>
                            </div>
                        </div> */}
                                                                        <div className="col-6 d-flex align-items-start">
                                                                            <div className="row desc">
                                                                                <div className="col-12"><span className="reporttext14mobile" >Type</span></div>
                                                                                <div className="col-12"><span className="reporttext12desc" > {element.type}</span></div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6 d-flex align-items-start">
                                                                            <div className="row desc">
                                                                                <div className="col-12"><span className="reporttext14mobile" >Interval</span></div>
                                                                                <div className="col-12"><span className="reporttext12desc" > {this.formatDateOnly(element.billingFromDate) + "-" + this.formatDateOnly(element.billingToDate)}</span></div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-6 d-flex align-items-start">
                                                                            <div className="row desc">
                                                                                <div className="col-12"><span className="reporttext14mobile" >Cost </span></div>
                                                                                <div className="col-12"><span className="reporttext12desc" >{this.state.currencySymbol}{element.cost}</span></div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6 d-flex align-items-start">
                                                                            <div className="row desc">
                                                                                <div className="col-12"><span className="reporttext14mobile" >Amount </span></div>
                                                                                <div className="col-12"><span className="reporttext12desc" >{this.state.currencySymbol}{element.amount}</span></div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-12 d-flex align-items-start">
                                                                            <div className="row desc">
                                                                                <div className="col-12"><span className="reporttext14mobile" >Licenses Assigned</span></div>
                                                                                <div className="col-12"><span className="reporttext12desc" > {element.licenseAssigned}</span></div>
                                                                            </div>
                                                                        </div>



                                                                    </div>
                                                                </div>
                                                            </div>)
                                                    })

                                                }
                                                <div className=''>
                                                    <div className=' me-5 ms-1'>
                                                        {this.state.invoiceSummary.map((e) => {
                                                            return (
                                                                <div className='d-flex col-12'>
                                                                    <label className='col-8 me-2 invoiceitemlabel'>{e.type}</label>
                                                                    <span className='col-4 invoicerupees'>{this.state.currencySymbol + e.value}</span>
                                                                </div>
                                                            )
                                                        })}

                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>



                                </div>

                                {/* FILTER SCREEN */}
                                <div
                                    className="offcanvas offcanvas-end pe-0"


                                    data-bs-scroll="false"
                                    data-bs-backdrop="false"
                                    id="FilterScreen1"
                                    aria-labelledby="offcanvasScrollingLabel"
                                >
                                    <div className={`offcanvas-header px-2  pb-1 mt-10`}>
                                        <h6
                                            id="offcanvasRightLabel"
                                            className="modal-title head-span"
                                            style={{ fontWeight: "600" }}
                                        >
                                            Filter
                                        </h6>
                                        <button
                                            className="offcavasclose"
                                            onClick={() => this.closeWebFilter()}
                                        >
                                            <CommonIcon fileName={"Close"} />
                                        </button>
                                    </div>

                                    <div className="offcanvas-body px-2 pt-0">
                                        <div className="row">
                                            <div
                                                className="row"
                                                style={{ padding: "1rem", paddingTop: "0" }}
                                            >
                                                <div className={`col-12 mt-2`}>
                                                    <TextField
                                                        id="jobOpTitle"
                                                        className="filter_input"
                                                        fullWidth
                                                        label="Invoice Number"
                                                        variant="filled"
                                                        value={this.state.choice.invoice_number}
                                                        onChange={(e) =>
                                                            this.lookupChange(e, "", "invoice_number")
                                                        }
                                                        focused
                                                    />
                                                </div>
                                                <div className={`col-12 mt-2`}>

                                                    <TextField
                                                        type='date'
                                                        id='jobOpOpenPositions'
                                                        fullWidth
                                                        label="Invoice from date"
                                                        className='filter_input'
                                                        variant="filled"
                                                        value={this.state.choice.invoice_date}
                                                        onChange={(e) => this.lookupChange(e, "", "invoice_fromdate")}
                                                        focused
                                                        disablePortal
                                                    />
                                                </div>
                                                <div className={`col-12 mt-2`}>

                                                    <TextField
                                                        type='date'
                                                        id='jobOpOpenPositions'
                                                        fullWidth
                                                        label="Invoice to date"
                                                        className='filter_input'
                                                        variant="filled"
                                                        value={this.state.choice.invoice_date}
                                                        onChange={(e) => this.lookupChange(e, "", "invoice_todate")}
                                                        focused
                                                        disablePortal
                                                    />
                                                </div>
                                                <div className={`col-12 mt-2`}>
                                                    <Autocomplete
                                                        focused
                                                        id="roleId"
                                                        variant="filled"
                                                        disablePortal
                                                        value={this.state.choice.status ? { status: this.state.choice.status } : null}
                                                        options={[
                                                            { id: "1", status: "Paid" },
                                                            { id: "2", status: "Pending" },
                                                            { id: "3", status: "Due" },

                                                        ]}
                                                        getOptionLabel={(option) => option.status || ""}
                                                        onChange={(e, selectedValue) =>
                                                            this.lookupChange(
                                                                e,
                                                                selectedValue,
                                                                "type"
                                                            )
                                                        }
                                                        renderOption={(props, option, { selected }) => (
                                                            <li {...props} key={option.id}>
                                                                {option.status}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="filled"
                                                                className="filter_input"
                                                                focused
                                                                label="Status"
                                                            />
                                                        )}
                                                    />
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 align_justify_end pb-20 pr-54">
                                            <Button
                                                className="btn-clear mr-10 border-none"
                                                variant="outlined"
                                                onClick={() => this.clearFilter()}
                                            >
                                                Reset
                                            </Button>
                                            <button
                                                className="btn-apply"
                                                variant="primary"
                                                onClick={() => this.applyFilter()}
                                            >
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>
                }
                <Backdrop className="spinner-backdrop" open={this.props.isLoading1}>
                    <CircularProgress color="primary" />
                </Backdrop>
            </>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggleMenu: () => dispatch(toggleMenu()) || false,

        dispatch
    };
};
function mapStateToProps(state) {
    return {
menuToggle: state.SideBarReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Billpayments)
);


